import { Table } from "../../../../../_helpers/Table";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getProjectsEstablishments } from "../../../../../_api/Project";

export const ProjectsTab = (props) => {
    const { currentApp, currentMenu, currentTab, user } = props;
    const navigate = useNavigate();

    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["COMPANY"]["features"];

    const { establishment_id } = useParams();
    const [data, setData] = useState([]);

    const headers = ["Nom", "# participants", "# heures"];

    const loadProjects = async () => {
        await getProjectsEstablishments(establishment_id).then((resp) => {
            setData(
                resp.data.map((res) => {
                    return {
                        row: [res.name, res.remarks, res.establishment_id],
                        data: res,
                    };
                })
            );
        });
    };
    const rowClick = (value) => {
        navigate(
            "/company/establishments/" +
            value.establishment_id +
            "/project/" +
            value.id
        );
    };

    useEffect(() => {
        loadProjects();
    }, [establishment_id]);

    return (
        <>
            <Table
                name={"Projet[s]"}
                isVisible={features_right['add_project']}
                addNavigate={
                    "/company/establishments/" +
                    establishment_id +
                    "/project/new"
                }
                headers={headers}
                rows={data}
                onClick={rowClick}
            />
        </>
    );
};
